import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class MockDataService {
  constructor(private http: HttpClient, private toastr: ToastrService) {}

  /**
   * Recursos de las personas de la api randomuser: https://randomuser.me
   *
   * @returns {Observable<any>}
   * @memberof MockDataService
   */
  getPeople(): Observable<any> {
    return new Observable(obs => {
      this.http.get<any>('https://randomuser.me/api/?results=100').subscribe(
        data => {
          const formattedData: any[] = [];
          data.results.forEach((el: any) => {
            formattedData.push({
              name: `${el.name.title} ${el.name.first} ${el.name.last}`,
              username: el.login.username,
              email: el.email,
              gender: el.gender,
              phone: el.phone
            });
          });
          obs.next(formattedData);
          obs.complete();
          this.toastr.success(`${data.results.length} personas consultadas.`, 'Operación exitosa');
        },
        err => {
          obs.error(err);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/examples/ng2-table/mock-data.service.ts